export default __webpack_public_path__ + "static/media/gold.cbf0f579.mp3";